<template>
  <div class="w-full mx-auto sm:max-w-5xl 2xl:max-w-6xl 3xl:max-w-8xl 4xl:max-w-9xl">
    <IntegrationsHeader />
    <LoginPrompt v-if="!isLoggedIn" />
    <IntegrationsGrid v-if="isLoggedIn" />
    <AppsSection />
    <ComingSoonSection />
    <WebhooksSettings v-if="isOrgUserAdmin && !isOrgUserViewOnly" />
  </div>
</template>

<script lang="ts" setup>
import IntegrationsHeader from './components/ui/IntegrationsHeader.vue';
import LoginPrompt from './components/ui/LoginPrompt.vue';
import IntegrationsGrid from './components/sections/IntegrationsGrid.vue';
import AppsSection from './components/sections/AppsSection.vue';
import ComingSoonSection from './components/sections/ComingSoonSection.vue';
import WebhooksSettings from './components/settings/WebhooksSettings.vue';
import { onMounted } from 'vue';
import { useIntegrationStore } from './store/useIntegrationStore';
import { useUserStore } from '@/store/useUserStore';
import { storeToRefs } from 'pinia';

const integrationStore = useIntegrationStore();
const userStore = useUserStore();

const { isLoggedIn, isOrgUserAdmin, isOrgUserViewOnly } = storeToRefs(userStore);

onMounted(() => {
  if (isLoggedIn.value) {
    integrationStore.fetchIntegrations();
  }
});
</script>
